import {
  Button,
  Flex,
  Icon,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Box,
  Link,
  Avatar,
  AvatarGroup,
  Heading,
  Stack,
  Container,
  Center,
  Divider,
  HStack,
} from "@chakra-ui/react";
import ShareModal from "./Features/ShareModal";
import { colorMain } from "../constants/themes";
import ProgressBar from "@ramonak/react-progress-bar";
import { FaShareAlt } from "react-icons/fa";
import DynamicButton from "./Features/DynamicButton";
import { shareUrl } from "../constants/variables";
import Footer from "./Features/Footer";
import DynamicDrawer from "./Features/DynamicDrawer";
import ConfirmModal from "./Features/ConfirmModal";
import Truncate from "./Features/Truncate";
import React, { useEffect, useState } from "react";

import { renderMessageWithLinksDesc, normalizeTimestamp, getYoutubeEmbedUrl } from "../utils/functions";
import { MdVerified, MdDateRange } from "react-icons/md";
import collectLogo from "../assets/img/nobukcollect.png";
import Approval from "../assets/img/Approval.svg";
import callendar from "../assets/img/callendar.svg";
import location from "../assets/img/location.svg";
import Moment from "react-moment";
import BusinessTemplate from "./collectTemplates/BusinessTemplate";
import SurveyDrawer from "./Features/SurveyDrawer";
import { ChevronLeftIcon, ChevronRightIcon, CheckCircleIcon } from "@chakra-ui/icons";

const CollectPage = React.memo(
  ({
    dataSale,
    jpg,
    setIsShare,
    isShare,
    data,
    type,
    mpesa,
    number,
    handleInput,
    nameOption,
    phoneLength,
    disabled,
    setName,
    setRecurring,
    recurring,
    setSelection,
    amount,
    opening,
    subActive,
    payLink,
    customerName,
    isRegisteredMember,
    isRegisteredPledgeMember,
    registeredOnly,
    buttonDisable,
    buttone,
    selection,
    setPledgeAmount,
    pledgeAmount,
    handlePledgeContribution,
    pledgeNumber,
    isToOpen,
    handleCloseThisModal,
    updating,
    paymentStatus,
    paidBy,
    phoneNumberBy,
    transactionCode,
    handleCardClick,
    handlePaymentRecheck,
    handleRepay,
    onOpen,
    trigger,
    name,
    isOpen,
    onClose,
    setAmount,
    handlePayment,
    setNumber,
    setPhoneLength,
    setPledgeNumber,
    setOpening,
    handleInputPledge,
    setCustomerName,
    setIsToOpen,
    urlOption,
    urlAmount,
    urlPhone,
    urlOptions,
    setPayType,
    payType,
    checkoutUrl,
    setCheckoutUrl,
    setVerify,
    verify,
    paymentData,
    trackCode,
    downloadPdf,
    toast,
    setOtherDetails,
    setSelectionDetails,
    saleId,
    defaultOptions,
    memberPay,
    subscribeData,
    sales_code,
    org_id,
    survey,
    setSurvey,
    reqSurveyId,
    setReqSurveyId,
    contactId,
    triggerSurvey,
    setTriggerSurvey,
    requestId,
    setRequestId,
    handlePaymentSurvey,
    isApiAmount,
    selection_details,
    logos,
    titleCase,
    imgUri,
    original_date,
  }) => {
    const [selectedOption, setSelectedOption] = useState(false);
    const [enteredAmount, setEnteredAmount] = useState(false);
    const [venue, setVenue] = useState();
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [detail, setDetail] = useState(
      data?.data?.saledata?.contact_detail || ""
    );

    const nextImage = () => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === (dataSale.sale_settings?.other_images?.length - 1) ? 0 : prevIndex + 1
      );
    };

    const prevImage = () => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === 0 ? (dataSale.sale_settings?.other_images?.length - 1) : prevIndex - 1
      );
    };

    // Add auto-rotation effect
    useEffect(() => {
      if (dataSale.sale_settings?.other_images?.length > 1) {
        const timer = setInterval(() => {
          nextImage();
        }, 7000); // Change image every 7 seconds

        return () => clearInterval(timer);
      }
    }, [currentImageIndex, dataSale.sale_settings?.other_images]);

    const current_level =
      data?.data?.saledata?.current_level >= 0 ? true : false;

    const clickComplete = () => {
      handlePaymentRecheck();
      setVerify(false);
      closeCheckOut();
    };

    const closeCheckOut = () => {
      setCheckoutUrl();
    };

    useEffect(() => {
      const regex = /{([^}]+)}/;

      const match = detail?.match(regex);

      if (match) {
        const ven = match[1];
        const updatedContactDetail = detail?.replace(`{${ven}}`, "");
        setDetail(updatedContactDetail);
        setVenue(ven);
      }
    }, [detail]);
    useEffect(() => {
      const digitRegex = /^\d+$/;

      if (urlOption && urlOptions?.some(opt => opt.value === urlOption?.trim())) {
        setSelectedOption(true);
        setSelection(urlOption);
      }

      if (urlPhone) {
        setNumber(urlPhone);
        const { number: num, length } = handleInput(urlPhone);
        setNumber(num);
        setPhoneLength(length);
      }

      if (!urlAmount) {
        if (urlOption && urlOptions?.some(opt => opt.value === urlOption?.trim())) {
          return;
        } else if (urlOption && digitRegex.test(urlOption)) {
          setEnteredAmount(true);
          setAmount(urlOption);
        }
      }

      if (urlAmount > 0) {
        setEnteredAmount(true);
      }
    }, [urlOption, urlPhone, urlAmount, urlOptions]);

    const commonProps = {
      placement: "bottom",
      isCentered: true,
      subActive: subActive,
      payLink: payLink,
      data: data,
      colorMain: colorMain,
      amount: amount,
      setAmount: setAmount,
      mpesa: mpesa,
      number: number,
      phoneLength: phoneLength,
      name: name,
      setName: setName,
      setRecurring: setRecurring,
      recurring: recurring,
      disabled: disabled,
      selection: selection,
      setSelection: setSelection,
      handleInput: handleInput,
      pledgeNumber: pledgeNumber,
      handleInputPledge: handleInputPledge,
      customerName: customerName,
      setCustomerName: setCustomerName,
      isRegisteredMember: isRegisteredMember,
      isRegisteredPledgeMember: isRegisteredPledgeMember,
      registeredOnly: registeredOnly,
      pledgeAmount: pledgeAmount,
      setPledgeAmount: setPledgeAmount,
      handlePledgeContribution: handlePledgeContribution,
      buttone: buttone,
      setPhoneLength: setPhoneLength,
      setPledgeNumber: setPledgeNumber,
      buttonDisable: buttonDisable,
      setNumber: setNumber,
      nameOption: nameOption,
      handlePayment: handlePayment,
      trigger: trigger,
      selectedOption: selectedOption,
      enteredAmount: enteredAmount,
      urlOptions: urlOptions,
      urlOption: urlOption,
      setPayType: setPayType,
      payType: payType,
      checkoutUrl: checkoutUrl,
      verify: verify,
      paymentData: paymentData,
      setOtherDetails: setOtherDetails,
      setSelectionDetails: setSelectionDetails,
      venue: venue,
      detail: detail,
      trackCode: trackCode,
      saleId: saleId,
      defaultOptions: defaultOptions,
      memberPay: memberPay,
      subscribeData: subscribeData,
      sales_code: sales_code,
      org_id: org_id,
      survey: survey,
      setSurvey: setSurvey,
      contactId: contactId,
      triggerSurvey: triggerSurvey,
      setTriggerSurvey: setTriggerSurvey,
      requestId: requestId,
      setRequestId: setRequestId,
      reqSurveyId: reqSurveyId,
      setReqSurveyId: setReqSurveyId,
      handlePaymentSurvey: handlePaymentSurvey,
      isApiAmount: isApiAmount,
      isItemSelected: selection_details?.length > 0
    };

    let template =
      data?.data.saledata?.sale_settings?.template_type || "default";

    let footerData = data?.data?.footer;

    const zenColor = "#003b49"; // Dark teal from reference image

    return (
      <Box minH="100vh" bg="gray.50" py={8} px={4} fontFamily="'Poppins', sans-serif">
        {/* Header with Logo */}
        <Center mb={6}>
          <Image
            src={collectLogo}
            objectFit="contain"
            h="32px"
            alt="Nobuk"
          />
        </Center>

        <Container maxW="md" p={0}>
          <Box
            bg="white"
            borderRadius="2xl"
            shadow="xl"
            overflow="hidden"
            position="relative"
          >
            {/* Checkout Modal */}
            <Modal
              isOpen={checkoutUrl}
              onClose={closeCheckOut}
              closeOnOverlayClick={false}
              isCentered
              motionPreset="slideInBottom"
              size="xl"
              preserveScrollBarGap="false"
            >
              <ModalOverlay backdropBlur={colorMain} />
              <ModalContent p={0}>
                <ModalHeader>Enter card details to pay</ModalHeader>
                <br />
                <ModalCloseButton />
                <ModalBody p={0}>
                  <iframe
                    src={checkoutUrl}
                    title="Paystack Checkout"
                    height="500"
                    width="100%"
                    frameBorder="0"
                  />
                </ModalBody>

                <ModalFooter gap={4}>
                  <DynamicButton
                    onClickHandler={clickComplete}
                    buttonText="Complete"
                    colorMain={zenColor}
                    isDisabled="true"
                  />
                </ModalFooter>
              </ModalContent>
            </Modal>

            {/* Share Button (Floating or Top Right) */}
            <Box position="absolute" top={4} right={4} zIndex={10}>
              <Button
                size="sm"
                colorScheme="whiteAlpha"
                bg="whiteAlpha.800"
                color={zenColor}
                borderRadius="full"
                onClick={() => {
                  shareUrl && setIsShare(true);
                }}
              >
                <Icon as={FaShareAlt} />
              </Button>
              <ShareModal
                isOpen={isShare}
                onClose={() => setIsShare(false)}
                shareUrl={shareUrl}
                data={data}
              />
            </Box>

            {/* Hero Image Section */}
            {dataSale.sale_settings?.banner_visible_show !== false &&
              dataSale.sale_settings?.banner_visible_show !== 0 &&
              dataSale.sale_settings?.banner_visible_show !== "false" && (
                <Box h="280px" position="relative" overflow="hidden" borderTopRadius="2xl">
                  {dataSale.sale_settings?.other_images && dataSale.sale_settings.other_images.length > 0 ? (
                    <>
                      <Box position="relative" w="100%" h="100%">
                        {dataSale.sale_settings.other_images.map((item, index) => (
                          <Box
                            key={index}
                            position="absolute"
                            top="0"
                            left="0"
                            w="100%"
                            h="100%"
                            opacity={index === currentImageIndex ? 1 : 0}
                            transition="opacity 0.5s"
                          >
                            <>{getYoutubeEmbedUrl(item.image) ? (
                              <Box
                                as="iframe"
                                src={getYoutubeEmbedUrl(item.image)}
                                title={item.text || "banner video"}
                                w="100%"
                                h="100%"
                                border="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                              />
                            ) : item.link ? (
                              <Link href={item.link} isExternal h="100%" w="100%">
                                <Image
                                  src={item.image}
                                  objectFit="cover"
                                  w="100%"
                                  h="100%"
                                  alt={item.text || "carousel image"}
                                />
                              </Link>
                            ) : (
                              <Image
                                src={item.image}
                                objectFit="cover"
                                w="100%"
                                h="100%"
                                alt={item.text || "carousel image"}
                              />
                            )}</>
                            {item.text && (
                              <Text
                                position="absolute"
                                bottom="4"
                                left="50%"
                                transform="translateX(-50%)"
                                color="white"
                                textAlign="center"
                                bg="blackAlpha.600"
                                px="4"
                                py="2"
                                borderRadius="md"
                                width="90%"
                                maxW="90%"
                                overflow="hidden"
                                whiteSpace="nowrap"
                                textOverflow="ellipsis"
                              >
                                {item.text}
                              </Text>
                            )}
                          </Box>
                        ))}
                        {dataSale.sale_settings.other_images.length > 1 && (
                          <>
                            <Button
                              position="absolute"
                              bottom="4"
                              left="50%"
                              transform="translateX(-50%)"
                              color="white"
                              zIndex="1"
                              size="sm"
                              borderRadius="full"
                            >
                              <ChevronLeftIcon />
                            </Button>
                            <Button
                              position="absolute"
                              right="2"
                              top="50%"
                              transform="translateY(-50%)"
                              onClick={nextImage}
                              bg="blackAlpha.600"
                              _hover={{ bg: "blackAlpha.700" }}
                              color="white"
                              zIndex="1"
                              size="sm"
                              borderRadius="full"
                            >
                              <ChevronRightIcon />
                            </Button>
                          </>
                        )}
                      </Box>
                    </>
                  ) : getYoutubeEmbedUrl(dataSale.sale_settings?.base_image) ? (
                    <Box
                      as="iframe"
                      src={getYoutubeEmbedUrl(dataSale.sale_settings?.base_image)}
                      title="collect with ease"
                      w="100%"
                      h="100%"
                      border="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    />
                  ) : (
                    <Image
                      src={dataSale.sale_settings?.base_image || jpg}
                      objectFit="cover"
                      w="100%"
                      h="100%"
                      alt="collect with ease"
                    />
                  )}
                </Box>
              )}

            {/* Content Section */}
            <Box p={6}>
              {/* Title */}
              <Heading
                as="h1"
                size="lg"
                textAlign="center"
                mb={2}
                color={zenColor}
                fontFamily="'Poppins', sans-serif"
                display="flex"
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                {data?.data.saledata.contact_name}
                <Icon as={MdVerified} color={zenColor} boxSize={6} />
              </Heading>



              {/* Progress Section */}
              {type !== "Wallet" && data?.data.saledata?.sale_settings?.progress_button_visible && (
                <Box mb={6} textAlign="center">
                  <Flex justifyContent="center" alignItems="baseline" mb={2}>
                    <Text fontSize="xl" fontWeight="bold" color="gray.800">
                      KES {Math.abs(
                        data?.data.saledata.sale_amount -
                        data?.data.saledata.sale_balance
                      ).toLocaleString()}
                    </Text>
                    {data?.data?.saledata.sale_amount !== 0 && (
                      <Text fontSize="md" color="gray.500" ml={2}>
                        of KES {(data?.data.saledata.sale_amount).toLocaleString()}
                      </Text>
                    )}
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Box flex="1">
                      <ProgressBar
                        completed={
                          data?.data.saledata.sale_amount !== 0
                            ? Math.ceil(
                              ((data?.data.saledata.sale_amount -
                                data?.data.saledata.sale_balance) /
                                data?.data.saledata.sale_amount) *
                              100
                            )
                            : 100
                        }
                        height="12px"
                        bgColor={zenColor}
                        baseBgColor="#EDF2F7"
                        isLabelVisible={false}
                        borderRadius="full"
                      />
                    </Box>
                    <Text fontSize="sm" fontWeight="bold" color="gray.600">
                      {data?.data.saledata.sale_amount !== 0
                        ? Math.ceil(
                          ((data?.data.saledata.sale_amount -
                            data?.data.saledata.sale_balance) /
                            data?.data.saledata.sale_amount) *
                          100
                        )
                        : 100}%
                    </Text>
                  </Flex>
                </Box>
              )}

              {template === "tickets" || template === "business" ? (
                <BusinessTemplate
                  data={data}
                  type={type}
                  trigger={trigger}
                  toast={toast}
                  trackCode={trackCode}
                  number={number}
                  commonProps={commonProps}
                  opening={opening}
                  setOpening={setOpening}
                  verify={verify}
                  isToOpen={isToOpen}
                  setIsToOpen={setIsToOpen}
                  handleCloseThisModal={handleCloseThisModal}
                  updating={updating}
                  paymentStatus={paymentStatus}
                  amount={amount}
                  paidBy={paidBy}
                  phoneNumberBy={phoneNumberBy}
                  transactionCode={transactionCode}
                  handleCardClick={handleCardClick}
                  handlePaymentRecheck={handlePaymentRecheck}
                  handleRepay={handleRepay}
                  selection={selection}
                  name={name}
                  payType={payType}
                  dataSale={dataSale}
                  downloadPdf={downloadPdf}
                  callendar={callendar}
                  location={location}
                  template={template}
                  urlOptions={urlOptions}
                  setSelection={setSelection}
                  selectedOption={selectedOption}
                  setAmount={setAmount}
                  setOtherDetails={setOtherDetails}
                  setSelectionDetails={setSelectionDetails}
                  venue={venue}
                  urlOption={urlOption}
                />
              ) : (
                <>
                  {template !== "realestate" && (
                    <Flex
                      alignItems="center"
                      justifyContent="flex-start"
                      gap={6}
                      mb={6}
                      wrap="wrap"
                    >
                      {/* Deadline / Date */}
                      {data?.data.saledata?.sale_settings?.add_end_date && (
                        <Flex alignItems="center" gap={2}>
                          <Image
                            src={callendar}
                            objectFit="contain"
                            w="20px"
                            h="20px"
                            opacity="0.7"
                            alt="Date"
                          />
                          <Flex flexDir="column">
                            <Text fontSize="xs" fontWeight="bold" color={colorMain} mb={0} lineHeight="shorter">
                              DATE
                            </Text>
                            <Text fontSize="sm" color="gray.600" fontWeight="medium" mb={0}>
                              {data?.data.saledata.sale_deadline ? (
                                <Moment format="D MMM YYYY">
                                  {data?.data.saledata.sale_deadline}
                                </Moment>
                              ) : (
                                <Moment format="D MMM YYYY">
                                  {data?.data.saledata.sales_date}
                                </Moment>
                              )}
                            </Text>
                          </Flex>
                        </Flex>
                      )}

                      {/* Location / Venue */}
                      {venue && (
                        <Flex alignItems="center" gap={2}>
                          <Image
                            src={location}
                            objectFit="contain"
                            w="20px"
                            h="20px"
                            opacity="0.7"
                            alt="Venue"
                          />
                          <Flex flexDir="column">
                            <Text fontSize="xs" fontWeight="bold" color={colorMain} mb={0} lineHeight="shorter">
                              VENUE
                            </Text>
                            <Text fontSize="sm" color="gray.600" fontWeight="medium" mb={0}>
                              {venue}
                            </Text>
                          </Flex>
                        </Flex>
                      )}
                    </Flex>
                  )}

                  <Box w="100%" mb={6}>
                    {(data?.data.saledata?.sale_settings?.add_about_collection ===
                      null ||
                      data?.data.saledata?.sale_settings?.add_about_collection) &&
                      type !== "Wallet" && (
                        <Box mb={4}>
                          <Text fontWeight="normal" color="gray.600" fontSize="sm" lineHeight="1.6" as="div">
                            {detail && (
                              <Truncate text={detail} maxLength={50} lines={3} isRichText>
                                {renderMessageWithLinksDesc(detail)}
                              </Truncate>
                            )}
                          </Text>
                        </Box>
                      )}

                    {/* Participants Section - Only show if progress bar is visible (sale_amount > 0) */}
                    {data?.data.saledata.sale_amount !== 0 && (
                      <HStack spacing={-2} mt={4}>
                        <AvatarGroup size="sm" max={3} borderColor="white">
                          {/* Placeholder avatars - in a real app, map through donor list */}
                          <Avatar name="Donor 1" src="https://bit.ly/dan-abramov" />
                          <Avatar name="Donor 2" src="https://bit.ly/ryan-florence" />
                          <Avatar name="Donor 3" src="https://bit.ly/kent-c-dodds" />
                        </AvatarGroup>
                        <Text
                          fontSize="xs"
                          color="gray.500"
                          ml={2}
                          fontFamily="'Poppins', sans-serif"
                        >
                          +{data?.data?.saledata?.current_level || 0} people
                        </Text>
                      </HStack>
                    )}

                    {/* Action Buttons & Modals */}
                    <Flex flexDirection="column" gap={3}>
                      {type === "Invoice" ||
                        type === "Sale" ||
                        type === "Collection" ||
                        type === "Wallet" ? (
                        <Flex flexDirection="column" gap={3}>
                          {data?.data.saledata?.sale_settings
                            ?.contribute_button_visible && (
                              <DynamicButton
                                onClickHandler={onOpen}
                                buttonText={
                                  data?.data.saledata?.sale_settings
                                    ?.contribute_button_name || "Click to Contribute"
                                }
                                isLoading={trigger}
                                colorMain={zenColor}
                              />
                            )}

                          {data?.data.saledata?.sale_settings
                            ?.pledge_button_visible && (
                              <DynamicButton
                                onClickHandler={() => setOpening(true)}
                                buttonText={
                                  data?.data.saledata?.sale_settings
                                    ?.pledge_button_name || "Pledge to contribute"
                                }
                                isLoading={trigger}
                                colorMain={zenColor}
                              />
                            )}

                          {data?.data.survey && data?.data.all_surveys && (
                            <Flex flexDirection="column" gap={3}>
                              {data.data.all_surveys.map((survey) => (
                                <DynamicButton
                                  key={survey.id}
                                  reqSurveyId={survey.id}
                                  onClickHandler={() => {
                                    setSurvey(true);
                                    setReqSurveyId(survey.id);
                                  }}
                                  buttonText={survey.survey_name}
                                  isLoading={trigger}
                                  colorMain={zenColor}
                                />
                              ))}
                            </Flex>
                          )}

                          {data?.data.saledata?.sale_settings
                            ?.download_receipt_visible &&
                            /statement/i.test(
                              data?.data.saledata?.sale_settings
                                ?.download_receipt_name || ""
                            ) && (
                              <DynamicButton
                                onClickHandler={() =>
                                  window.open("/statement", "_blank")
                                }
                                buttonText={
                                  data?.data.saledata?.sale_settings
                                    ?.download_receipt_name
                                }
                                colorMain={zenColor}
                              />
                            )}
                        </Flex>
                      ) : null}

                      <DynamicDrawer
                        isOpen={isOpen}
                        onClose={onClose}
                        contributionMode="pay"
                        buttonText={
                          data?.data.saledata?.sale_settings
                            ?.contribute_button_name || "click to pay"
                        }
                        {...commonProps}
                      />



                      <DynamicDrawer
                        isOpen={opening}
                        onClose={() => setOpening(false)}
                        contributionMode="pledge"
                        buttonText={
                          data?.data.saledata?.sale_settings
                            ?.pledge_button_name || "Make a Pledge"
                        }
                        {...commonProps}
                      />
                      {!verify && (
                        <ConfirmModal
                          isToOpen={isToOpen}
                          setIsToOpen={setIsToOpen}
                          paymentStatus={paymentStatus}
                          paidBy={paidBy}
                          phoneNumberBy={phoneNumberBy}
                          transactionCode={transactionCode}
                          handleRepay={handleRepay}
                          amount={amount}
                          handlePaymentRecheck={handlePaymentRecheck}
                          updating={updating}
                          handleCloseThisModal={handleCloseThisModal}
                          details={dataSale}
                        />
                      )}
                    </Flex>
                  </Box>
                </>
              )}

              <SurveyDrawer
                isOpen={survey}
                onClose={() => {
                  setSurvey(false);
                }}
                contributionMode="pay"
                buttonText={
                  data?.data.saledata?.sale_settings
                    ?.survey_button_name || "Take Survey"
                }
                {...commonProps}
              />
            </Box>
          </Box>
        </Container>
        {(Array.isArray(footerData)
          ? footerData.some((f) => f?.adshow)
          : footerData?.adshow) && (
          <Container maxW="md" p={0} mt={4}>
            <Box borderRadius="xl" overflow="hidden" shadow="md">
              <Footer footerData={
                Array.isArray(footerData)
                  ? footerData.filter((f) => f?.adshow)
                  : footerData
              } />
            </Box>
          </Container>
        )}
      </Box>
    );
  }
);

export default CollectPage;
